import { computed, inject, Injectable, signal } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { IndicationsListComponent } from '../components/indications-list/indications-list.component';
import { NewDetailsPage } from 'src/app/pages/new-details/new-details.page';
import { BottomSheetConfig } from 'src/app/interfaces/mat.interface';
import { Transfers } from '../../../interfaces/custom-route.interface';

@Injectable({ providedIn: 'root' })

export class IndicatorsService {
  private _bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  public bottomSheetRef = signal<MatBottomSheetRef | null>(null);
  private isOpening = signal<boolean>(false);
  private detailsId = signal<number>(null);

  private intructions = signal<string>(undefined);
  private timeRemaining = signal<number>(undefined);
  private stepProgress = signal<number>(undefined);
  private nextItem = signal<string>(undefined);
  private sign = signal<string>(undefined);
  
  public getInstructions = computed<string>(() => this.intructions());
  public getTimeRemaining = computed<number>(() => this.timeRemaining());
  public getStepProgress = computed<number>(() => this.stepProgress());
  public getNextItem = computed<string>(() => this.nextItem());
  public getSign = computed<string>(() => this.sign());
  
  // ----- DETAILS ----------------------------------------------------------------------------------------------------------------
    public openBottomSheetDetailsMobile(id: number, type: string): void {
      if (this.isOpening())
        return;

      const bottomSheetConfig: BottomSheetConfig<NewDetailsPage, any> = {
        component: NewDetailsPage,
        data: {
          id: id,
          type: type,
          fromPointPlannerCustomRouteMobile: true,
          isModal: true
        },
        panelClass: 'details-bottom-sheet--mobile',
      }

      this.isOpening.set(true);
      this.bottomSheetRef.set(this._bottomSheet.open(NewDetailsPage, bottomSheetConfig));
      this.bottomSheetRef().afterDismissed().subscribe(() => {
          this.bottomSheetRef.set(null);
      });
      this.bottomSheetRef().afterOpened().subscribe(() => {
        this.isOpening.set(false);
      });
    }

    public openBottomSheetDetailsDesktop(id: number, type: string): void {
      if (this.isOpening())
        return;

      if (this.detailsId() === id && this._bottomSheet._openedBottomSheetRef){
        this._bottomSheet?.dismiss();
        this.detailsId.set(null);
        return;
      }

      if (this._bottomSheet._openedBottomSheetRef){
        this._bottomSheet?.dismiss();
        this.isOpening.set(true);
        this._bottomSheet._openedBottomSheetRef.afterDismissed().subscribe(() => {
          this.detailsId.set(null);
          this.loadDetailsDesktop(id, type);
        });
        return;
      }
      this.loadDetailsDesktop(id, type);
    }

    loadDetailsDesktop(id: number, type: string): void{
      this.isOpening.set(true);
      const bottomSheetConfig: BottomSheetConfig<NewDetailsPage, any> = {
        component: NewDetailsPage,
        data: {
          id: id, 
          type: type,
          fromPointPlannerCustomRouteDesktop: true,
          isModal: true
        },
        panelClass: 'details-bottom-sheet--desktop',
      }
      this._bottomSheet.open(NewDetailsPage, bottomSheetConfig);
      this._bottomSheet._openedBottomSheetRef.afterOpened().subscribe(() => {
        this.isOpening.set(false);
      })

      this.detailsId.set(id);
    }


  // ----- TRANSFERS ----------------------------------------------------------------------------------------------------------------
    public openBottomSheetTransfersMobile(transfers: Transfers[]): void {
      if (this.isOpening())
        return;

      const bottomSheetConfig: BottomSheetConfig<IndicationsListComponent, any> = {
        component: IndicationsListComponent,
        data: {
            transfers: transfers,
            fromPointPlannerCustomRouteMobile: true,
        },
        panelClass: 'indications-list-bottom-sheet--mobile',
      }

      this.isOpening.set(true);
      this.bottomSheetRef.set(this._bottomSheet.open(IndicationsListComponent, bottomSheetConfig));
      this.bottomSheetRef().afterDismissed().subscribe(() => {
          this.bottomSheetRef.set(null);
      });
      this.bottomSheetRef().afterOpened().subscribe(() => {
        this.isOpening.set(false);
      });
    }

    public openBottomSheetTransfersDesktop(transfers: Transfers[]): void {
      if (this.isOpening())
        return;

      if (this._bottomSheet._openedBottomSheetRef){
        this._bottomSheet?.dismiss();
        return;
      }
      this.loadTransfersDesktop(transfers);
    }

    loadTransfersDesktop(transfers: Transfers[]): void{
      this.isOpening.set(true);
      const bottomSheetConfig: BottomSheetConfig<IndicationsListComponent, any> = {
        component: IndicationsListComponent,
        data: {
            transfers: transfers,
            fromPointPlannerCustomRouteDesktop: true,
        },
        panelClass: 'indications-list-bottom-sheet--desktop',
      }
      this._bottomSheet.open(IndicationsListComponent, bottomSheetConfig);
      this._bottomSheet._openedBottomSheetRef.afterOpened().subscribe(() => {
        this.isOpening.set(false);
      });
    }

// ----- AUXILIAR FUNCTIONS ----------------------------------------------------------------------------------------------------------------
    public closeAll(): void{
      this._bottomSheet?.dismiss();
    }

    public resetInstructions(): void{
      this.intructions.set(null);
      this.sign.set(null);
      this.nextItem.set(null);
      this.stepProgress.set(null);
      this.timeRemaining.set(null);
    }

    public setInstructions(currentStep: Transfers, nextPoint: string = undefined): void{
      const sign = currentStep?.mode === 'walking' ? currentStep.iconName : currentStep?.mode?.toLowerCase();
      this.intructions.set(currentStep?.instruction);
      this.sign.set(sign);
      this.nextItem.set(nextPoint);
    }

    public setTimeRemainig(time: number): void{
      this.timeRemaining.set(time);
    }

    public setStepProgress(progress: number): void{
      this.stepProgress.set(progress)
    }

}